import { AuthWrapper } from '@features/auth/AuthWrapper/RegistrationWrapper';

export const Registration = () => {
	return <AuthWrapper />;
};
